/* eslint-disable import/prefer-default-export */
import _capitalize from 'lodash/capitalize';

export const constantToString = (constant) => {
  const text = constant || '';
  return _capitalize(text.split('_').join(' '));
};
